export const endpoints = {
  address: '/address',
  order: '/order',
}
